export const FB_PIXEL_ID = '1545009850674181'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

let initialized = false

/**
 * True when running inside an iframe (e.g. the Magic Patterns preview /
 * editor sandbox). Loading the cross-origin Meta Pixel script there can be
 * blocked by CSP and surface as an opaque "Script error.", so we skip it.
 */
function isPreviewSandbox(): boolean {
  try {
    return window.self !== window.top
  } catch {
    // Access to window.top threw => we are cross-origin framed => sandbox.
    return true
  }
}

/**
 * Loads the official Meta (Facebook) Pixel base code and fires PageView.
 * Fails silently and never throws so it can't crash the app.
 */
export function initFbPixel(): void {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  // Only run the pixel on the real published (top-level) page.
  if (isPreviewSandbox()) return

  try {
    /* eslint-disable */
    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      t.onerror = function () {
        /* swallow load failures silently */
      }
      const s = b.getElementsByTagName(e)[0]
      s.parentNode?.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */

    window.fbq?.('init', FB_PIXEL_ID)
    window.fbq?.('track', 'PageView')
  } catch {
    /* never let the pixel break the page */
  }
}

export function trackFbEvent(
  event: string,
  data?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return
  try {
    window.fbq('track', event, data)
  } catch {
    /* ignore */
  }
}
